module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Cadastrar Membro Externo'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "black--text font-weight-bold"
  }, [_vm._v("\n                        Cadastre o membro externo preenchendo os dados do formulário abaixo. Caso o membro externo necessite ter acesso aos sistemas corporativos da UFES ou ao\n                        "), _c('a', {
    attrs: {
      "href": "http://nti.ufes.br/eduroam",
      "target": "_blank"
    }
  }, [_vm._v("Eduroam")]), _vm._v(", o cadastro deve ser realizado por meio do sistema "), _c('a', {
    attrs: {
      "href": "url",
      "id": "excadLink",
      "target": "_blank"
    }
  }, [_vm._v("ExCAD - Extensão do Cadastro")]), _vm._v(".\n                        Para obter maiores informações sobre o sistema ExCAD, clique no link a seguir: "), _c('a', {
    attrs: {
      "href": "http://www.sti.ufes.br/excad-extensao-de-cadastro-de-pessoas-sem-vinculo",
      "target": "_blank"
    }
  }, [_vm._v("STI - Serviços web - ExCAD")]), _vm._v(".\n                      ")])], 1)], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "mandatory": "",
      "label": "O membro externo é estrangeiro?"
    },
    model: {
      value: (_vm.pessoa.estrangeiro),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "estrangeiro", $$v)
      },
      expression: "pessoa.estrangeiro"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome*",
      "counter": "200",
      "rules": _vm.obrigatorio.concat( _vm.max200caracteres),
      "max-height": "400"
    },
    model: {
      value: (_vm.pessoa.nome),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "nome", $$v)
      },
      expression: "pessoa.nome"
    }
  })], 1)], 1), _vm._v(" "), (_vm.pessoa.estrangeiro === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Possui nome social?"
    },
    model: {
      value: (_vm.temNomeSocial),
      callback: function($$v) {
        _vm.temNomeSocial = $$v
      },
      expression: "temNomeSocial"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.temNomeSocial) ? _c('v-text-field', {
    attrs: {
      "label": "Nome Social*",
      "counter": "200",
      "rules": _vm.obrigatorio.concat( _vm.max200caracteres),
      "max-height": "400"
    },
    model: {
      value: (_vm.pessoa.nomeSocial),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "nomeSocial", $$v)
      },
      expression: "pessoa.nomeSocial"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pessoa.estrangeiro === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field-cpf', {
    attrs: {
      "label": "CPF*",
      "options": {
        outputMask: '###.###.###-##',
      },
      "properties": {
        rules: _vm.obrigatorio
      }
    },
    model: {
      value: (_vm.pessoa.cpf),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "cpf", $$v)
      },
      expression: "pessoa.cpf"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pessoa.estrangeiro === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Passaporte*",
      "counter": "40",
      "rules": _vm.obrigatorio.concat( _vm.max40caracteres)
    },
    model: {
      value: (_vm.pessoa.passaporte),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "passaporte", $$v)
      },
      expression: "pessoa.passaporte"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.cadastraMembroExterno()
      }
    }
  }, [_vm._v("Cadastrar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2570467a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pesquisa/cadastrar-membro-externo.vue
// module id = 847
// module chunks = 0